import React, { useEffect, useState } from "react";
// import Card from '@gerenciatd/next.components.card-n';
import {
  handlingCodes,
  maintenanceStopperTexts,
  serverErrorText,
} from "@/constants/constants";
import RouteHandler from "@/components/page-handler";
import ErrorScreen from "@/components/ErrorScreen/ErrorScreen";
import Login from "@/components/login/login";
import { PROJECT_URLS } from "@/constants/project-urls";
// import { isFrontApp } from '@gerenciatd/next.utils.common';
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actions as initActions } from "@/reducers/initPage";
import maintenance from "./assets/mantenimiento.svg";
import fatal from "./assets/fatalError.svg";

const Stopper = ({ handlingCode }) => {
  const dispatch = useDispatch();
  const locationActual = useLocation();
  const [locationPre, setLocationPre] = useState(null);

  useEffect(() => {
    if (locationPre !== locationActual.pathname) {
      if (locationPre !== null) {
        dispatch(initActions.setError(0));
      }
      setLocationPre(locationActual.pathname);
    }
    if(locationActual && locationActual.pathname){
      let allUrls=Object.values(PROJECT_URLS)
      allUrls=allUrls.map(x=>`${x}/`);
      let locationPathnameWithoutFinalSlash=locationActual.pathname;
      if(locationPathnameWithoutFinalSlash){
        locationPathnameWithoutFinalSlash.length
      }
      const includedUrl=allUrls.includes(locationActual.pathname)
      if(!includedUrl){
        RouteHandler.updatePageProps({ location: PROJECT_URLS.MIS_PRODUCTOS });
      }
    }
  }, [locationActual]);

  if (!handlingCode) {
    // fake...
    return null;
  }

  return (
    <div className="Stopper">
      {handlingCode === handlingCodes.FATAL && (
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              {/* <Card> */}
              <ErrorScreen
                errorTitle={serverErrorText.errorTitle2}
                errorMessage={serverErrorText.errorMessage2}
                errorImage={fatal}
                fatalError
                errorAlt={serverErrorText.errorAlt2}
              />
              {/* </Card> */}
            </div>
          </div>
        </div>
      )}
      {handlingCode === handlingCodes.UPGRADE && (
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <Login />
            </div>
          </div>
        </div>
      )}
      {handlingCode === handlingCodes.MAINTENANCE && (
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              {/* <Card> */}
              <ErrorScreen
                errorTitle={maintenanceStopperTexts.errorTitle}
                errorSubtitle={maintenanceStopperTexts.errorSubtitle}
                errorImage={maintenance}
                errorAlt={maintenanceStopperTexts.errorAlt}
              />
              {/* </Card> */}
            </div>
          </div>
        </div>
      )}
      {handlingCode === -69 && (
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              {/* <Card>
                <ErrorScreen
                  errorTitle={frontErrorText.errorTitle}
                  errorMessage={frontErrorText.errorSubtitle}
                  errorImage={fatal}
                  fatalError
                  errorAlt={frontErrorText.errorAlt}
                />
              </Card> */}

              {/* <Card> */}
              <ErrorScreen
                errorTitle={serverErrorText.errorTitle2}
                errorMessage={serverErrorText.errorMessage2}
                errorImage={fatal}
                fatalError
                errorAlt={serverErrorText.errorAlt2}
              />
              {/* </Card> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Stopper;
